import { isValid } from "date-fns";
import { parseBackendTimestamp } from "../../../utils/backend-dates";

/**
 * Resolves a form field value into a Date instance or null for date picker inputs.
 * - Preserves Date instances
 * - Converts numeric epoch timestamps (milliseconds) with proper date semantics
 * - Parses naive backend timestamp strings as UTC via parseBackendTimestamp
 * - Parses ISO timestamp strings with timezone offsets
 * - Returns null for null, undefined, empty strings, or invalid dates
 */
export function resolveFormDateTimeValue(
  value: Date | string | number | null | undefined
): Date | null {
  if (value == null || value === "") return null;
  if (value instanceof Date) return isValid(value) ? value : null;
  if (typeof value === "number") {
    const date = new Date(value);
    return isValid(date) ? date : null;
  }
  if (typeof value === "string") {
    if (/^\d+$/.test(value)) {
      const date = new Date(Number(value));
      return isValid(date) ? date : null;
    }
    const date = parseBackendTimestamp(value);
    return isValid(date) ? date : null;
  }
  const date = new Date(value);
  return isValid(date) ? date : null;
}
